import { useCallback } from 'react';

import { setDoc, doc, serverTimestamp } from 'firebase/firestore';

import { useFirestore } from '@anyx/external-firebase';
import { reportAppError } from '@anyx/shared-utils';


export const useNotificationsMarkAsRead = ({ userId }: { userId: string }) => {
  const { firestore } = useFirestore();
  const markAsRead = useCallback(
    async (notificationId: string) => {
      try {
        if (!firestore) {
          console.warn('Firestore is not initialized');
          return;
        }
        if (!userId || !notificationId) {
          console.warn('Invalid userId or notificationId', { userId, notificationId });
          return;
        }

        await setDoc(
          doc(firestore, `users/${userId}/notificationStates/${notificationId}`),
          {
            read: true,
            readAt: serverTimestamp(),
          },
          { merge: true }
        );
      } catch (err) {
        console.error('Failed to mark notification as read:', err);
        reportAppError(err);
      }
    },
    [firestore, userId]
  );

  return {
    markAsRead,
  };
};
